import React, { useState, useEffect } from 'react';
import SideBar from './Components/SideBar'; 
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DatabaseUtil from './Util/DatabaseUtil';
import Panels from './Components/Panels'; 
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function DashSummary() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [videoCount, setVideoCount] = useState(0);
    const [totalViews, setTotalViews] = useState(0);
    const [totalLikes, setTotalLikes] = useState(0);
    const [totalComments, setTotalComments] = useState(0);
    const [averageWatchtime, setAverageWatchtime] = useState(0);
    const [topVideos, setTopVideos] = useState([]);
    const [topLikedVideos, setTopLikedVideos] = useState([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        
        const fetchData = async () => {
            setLoading(true);
            setError(null);
            try {
                const count = await DatabaseUtil.countDocumentsInVideos();
                setVideoCount(count);
                const { totalLikes, totalComments } = await DatabaseUtil.getLikesAndComments();
                const { totalViews, averageWatchtime } = await DatabaseUtil.getViewsAndWatchtime();
                setTotalViews(totalViews);
                setTotalLikes(totalLikes);
                setTotalComments(totalComments);
                setAverageWatchtime(averageWatchtime);

                const topVideosData = await DatabaseUtil.getTopVideosByViews();
                setTopVideos(topVideosData);

                const topLikedVideosData = await DatabaseUtil.getTopVideosByLikes();
                setTopLikedVideos(topLikedVideosData);
            } catch (error) {
                console.error('Failed to fetch data:', error);
                setError('Failed to load dashboard data.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const generateBarChartViews = () => {
        // Filter out intro videos
        const filteredVideos = topVideos.filter(video => 
            !/ENG|ESP/i.test(video.id) && !/ENG|ESP/i.test(video.title)
        );
    
        const labels = filteredVideos.map(video => video.title);
        const data = filteredVideos.map(video => video.totalViews);
    
        return {
            labels,
            datasets: [
                {
                    label: t('views'),
                    data,
                    backgroundColor: '#ffffff',
                    borderColor: '#001f3f',
                    borderWidth: 0,
                },
            ],
        };
    };
    const generateBarChartLikes = () => {
        // Filter out intro videos
        const filteredVideos = topLikedVideos.filter(video => 
            !/ENG|ESP/i.test(video.title)
        );

        const labels = filteredVideos.map(video => video.title);
        const data = filteredVideos.map(video => video.totalLikes);

        return {
            labels,
            datasets: [
                {
                    label: t('likes'),
                    data,
                    backgroundColor: '#ffffff',
                    borderColor: '#001f3f',
                    borderWidth: 0,
                },
            ],
        };
    };

    const chartOptions = {
        plugins: {
            legend: {
                labels: {
                    color: '#ffffff', 
                    font: {
                        size: 16,
                        family: 'KomikaAxis'
                    },
                },
            },
            tooltip: {
                titleColor: '#ffffff', 
                bodyColor: '#ffffff',  
                
            },
        },
        scales: {
            x: {
                ticks: {
                    color: '#ffffff',
                    font: {
                        size: 10,
                        family: 'KomikaAxis'
                    },
                },
                /*grid: {
                    color: '#ffffff', 
                },*/

            },
            y: {
                ticks: {
                    color: '#ffffff', 
                    font: {
                        size: 12,
                        family: 'KomikaAxis'
                    },
                },
                grid: {
                    color: '#ffffff', 
                    
                },
                
            },
        },
    };

    return (
        <>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <div style={{ padding: '20px', fontFamily: 'KomikaAxis', }}>
                <h2 style={{ fontFamily: 'KomikaAxis', color: 'var(--primary-color)'}}>{t('summary')}</h2>
                {loading ? (
                    <p>Loading...</p>
                ) : error ? (
                    <p style={{ color: 'red' }}>{error}</p>
                ) : (
                    <>
                        <div 
                            style={{ 
                                display: 'flex', 
                                /*flexWrap: 'wrap', */
                                gap: '20px',
                                alignItems: 'center', 
                                maxWidth: '100%',
                                color: 'var(--primary-white-color)',
                            }}
                        >
                            <Panels type='default' title={t('totalVideos')} value={videoCount} onClick={() => navigate('/dashvideosummary')} />
                            <Panels type='default' title={t('totalVideoViews')} value={totalViews} />
                            <Panels type='default' title={t('totalLikes')} value={totalLikes} />
                        </div>

                    </>
                )}
                <SideBar />
            </div>
            <div style={{ marginTop: '10px', backgroundColor:'var(--primary-color)', borderRadius: '8px', 
            color: 'white', width: '60%', }}>
                            <h3>{t('topVideos')}</h3>
                            <Bar 
                                data={generateBarChartViews()}
                                options={chartOptions}
                            />
                        </div>
                        <div style={{ marginTop: '10px', backgroundColor:'var(--primary-color)',  padding: '20px', borderRadius: '8px', 
            color: 'white', width: '60%', }}>
                <h3>{t('topLikedVideos')}</h3>
                <Bar 
                    data={generateBarChartLikes()}
                    options={chartOptions}
                />
            </div>
        </div>
        </>
    );
}

export default DashSummary;
